const CryptodraftActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  UPDATE_TERMS_STATUS: 'update_terms_status',
  UPDATE_IS_EXTENED: 'update_is_extended',
  UPDATE_ALLOWED_WALLETS: 'update_allowed_wallets',
  UPDATE_ALLOWED_SETTLEMENTS_WALLETS: 'update_allowed_settelements_wallets',
  UPDATE_SELECTED_WALLET: 'update_selected_wallet',
  UPDATE_SELECTED_SETTLEMENTS_WALLET: 'update_selected_settelement_wallet',
  UPDATE_COLLATERAL_AMOUNT: 'update_collateral_amount',
  UPDATE_CRYPTODRAFT_SETTINGS: 'update_cryptodraft_settings',
  UPDATE_ADDITIONAL_AMOUNT_NEEDED: 'update_additional_amount_needed',
  UPDATE_FIAT_CURRENCY: 'update_fiat_currency',
  UPDATE_PRINCIPAL_CURRENCY: 'update_principal_currency',
  UPDATE_USER: 'update_user',
  UPDATE_PGW_REQUEST_PARAMS: 'update_pgw_request_params',
  UPDATE_CRYPTODRAFT_DETAILS: 'update_cryptodraft_details',
  UPDATE_CRYPTODRAFT_SETTLEMENT_DETAILS: 'update_cryptodraft_settlement_details',
  UPDATE_HINTS_VISIBLILITY: 'update_hints_visibility',
  UDPATE_CRYPTODRAFT_TIER_LTV: 'update_cryptodraft_tier_ltv',
  FORCE_UPDATE: 'force_update',
  FORCE_RESET: 'force_reset',
};

const CryptodraftReducer = (state, action) => {
  switch (action.type) {
    case CryptodraftActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case CryptodraftActionTypes.UPDATE_TERMS_STATUS:
      return { ...state, termsOpened: action.payload };
    case CryptodraftActionTypes.UPDATE_IS_EXTENED:
      return { ...state, isExtendCryptodraft: !state.isExtendCryptodraft };
    case CryptodraftActionTypes.UPDATE_ALLOWED_WALLETS:
      return { ...state, allowedWallets: action.payload };
    case CryptodraftActionTypes.UPDATE_ALLOWED_SETTLEMENTS_WALLETS:
      return { ...state, allowedSettlementWallets: action.payload };
    case CryptodraftActionTypes.UPDATE_SELECTED_WALLET:
      return { ...state, selectedWallet: action.payload };
    case CryptodraftActionTypes.UPDATE_SELECTED_SETTLEMENTS_WALLET:
      return { ...state, selectedSettlementWallet: action.payload };
    case CryptodraftActionTypes.UPDATE_COLLATERAL_AMOUNT:
      return { ...state, collateralAmount: action.payload };
    case CryptodraftActionTypes.UPDATE_CRYPTODRAFT_SETTINGS:
      return { ...state, cryptodraftSettings: action.payload };
    case CryptodraftActionTypes.UPDATE_ADDITIONAL_AMOUNT_NEEDED:
      return { ...state, additionalAmountNeeded: action.payload };
    case CryptodraftActionTypes.UPDATE_FIAT_CURRENCY:
      return { ...state, fiatCurrency: action.payload };
    case CryptodraftActionTypes.UPDATE_PRINCIPAL_CURRENCY:
      return { ...state, principalCurrency: action.payload };
    case CryptodraftActionTypes.UPDATE_PGW_REQUEST_PARAMS:
      return { ...state, pgwRequestParams: action.payload };
    case CryptodraftActionTypes.UPDATE_CRYPTODRAFT_DETAILS:
      return { ...state, cryptodraftDetails: action.payload };
    case CryptodraftActionTypes.UPDATE_CRYPTODRAFT_SETTLEMENT_DETAILS:
      return { ...state, cryptodraftSettlementDetails: action.payload };
    case CryptodraftActionTypes.UDPATE_CRYPTODRAFT_TIER_LTV:
      return { ...state, cryptodraftTierLTV: action.payload };
    case CryptodraftActionTypes.UPDATE_HINTS_VISIBLILITY:
      return {
        ...state,
        hintsOpened: action.payload,
      };
    case CryptodraftActionTypes.FORCE_UPDATE:
      return {
        ...state,
        forceUpdate: {
          ...state.forceUpdate,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case CryptodraftActionTypes.FORCE_RESET:
      return {
        ...state,
        forceReset: {
          ...state.forceReset,
          [`${action.payload.key}`]: action.payload.value,
        },
      };
    case CryptodraftActionTypes.UPDATE_USER:
      return {
        ...state,
        user: { isUS: action.payload.isUS, cardProvider: action.payload.cardProvider },
      };
    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: CryptodraftActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const openTerms = (dispatch) => () =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_TERMS_STATUS, payload: true });

const closeTerms = (dispatch) => () =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_TERMS_STATUS, payload: false });

const updateIsExtendCryptodraft = (dispatch) => () =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_IS_EXTENED });

const updateCryptodraftAllowedWallets = (dispatch) => (wallets) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_ALLOWED_WALLETS, payload: wallets });

const updateCryptodraftAllowedSettlementsWallets = (dispatch) => (wallets) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_ALLOWED_SETTLEMENTS_WALLETS, payload: wallets });

const updateSelectedWallet = (dispatch) => (wallet) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_SELECTED_WALLET, payload: wallet });

const updateSelectedSettlementWallet = (dispatch) => (wallet) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_SELECTED_SETTLEMENTS_WALLET, payload: wallet });

const updateCollateralAmount = (dispatch) => (amount) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_COLLATERAL_AMOUNT, payload: amount });

const updateCryptodraftSettings = (dispatch) => (settings) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_CRYPTODRAFT_SETTINGS, payload: settings });

const updateAdditionalAmountNeeded = (dispatch) => (amount) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_ADDITIONAL_AMOUNT_NEEDED, payload: amount });

const updateFiatCurrency = (dispatch) => (currency) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_FIAT_CURRENCY, payload: currency });

const updatePrincipalCurrency = (dispatch) => (currency) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_PRINCIPAL_CURRENCY, payload: currency });

const updateUser = (dispatch) => (userData) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_USER, payload: userData });

const updatePgwRequestParams = (dispatch) => (PGWParams) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_PGW_REQUEST_PARAMS, payload: PGWParams });

const updateCryptodraftDetails = (dispatch) => (details) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_CRYPTODRAFT_DETAILS, payload: details });

const updateCryptodraftSettelementDetails = (dispatch) => (details) =>
  dispatch({
    type: CryptodraftActionTypes.UPDATE_CRYPTODRAFT_SETTLEMENT_DETAILS,
    payload: details,
  });

const updateHintsVisibility = (dispatch) => (hintsVisibility) =>
  dispatch({ type: CryptodraftActionTypes.UPDATE_HINTS_VISIBLILITY, payload: hintsVisibility });

const updateCryptodraftTierLTV = (dispatch) => (ltv) =>
  dispatch({ type: CryptodraftActionTypes.UDPATE_CRYPTODRAFT_TIER_LTV, payload: ltv });

const forceUpdateAction = (dispatch) => (key, value) =>
  dispatch({ type: CryptodraftActionTypes.FORCE_UPDATE, payload: { key, value } });

const forceResetAction = (dispatch) => (key, value) =>
  dispatch({ type: CryptodraftActionTypes.FORCE_RESET, payload: { key, value } });

// eslint-disable-next-line import/prefer-default-export
export const cryptodraft = {
  CryptodraftReducer,
  actions: {
    openScreen,
    openTerms,
    closeTerms,
    updateIsExtendCryptodraft,
    updateCryptodraftAllowedWallets,
    updateSelectedWallet,
    updateSelectedSettlementWallet,
    updateCollateralAmount,
    updateCryptodraftSettings,
    updateAdditionalAmountNeeded,
    updateFiatCurrency,
    updatePrincipalCurrency,
    updateUser,
    updatePgwRequestParams,
    updateCryptodraftDetails,
    updateCryptodraftSettelementDetails,
    updateCryptodraftAllowedSettlementsWallets,
    updateHintsVisibility,
    updateCryptodraftTierLTV,
    forceUpdateAction,
    forceResetAction,
  },
};
